export const SITE = {
  name: "Paramount Kitchen",
  tagline: "Beautiful by Design. Engineered to Last.",
  sub: "Premium modular kitchens crafted with precision, carefully selected materials and a construction process designed for the demands of everyday Indian kitchens.",
  location: "Kangra District, Himachal Pradesh, India",
  phoneDisplay: "+91 62304 92888",
  phoneHref: "tel:+916230492888",
  whatsappNumber: "916230492888",
  email: "paramountinteriorsolutions@gmail.com",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Kangra+District%2C+Himachal+Pradesh",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const DEFAULT_WA_MSG =
  "Hi Paramount Kitchen! I would like to know more about your premium modular kitchens.";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Kitchens", to: "/kitchens" },
  { label: "Carcass & Construction", to: "/carcass" },
  { label: "Our Process", to: "/process" },
  { label: "Materials & Hardware", to: "/materials" },
  { label: "Accessories", to: "/accessories" },
  { label: "About Us", to: "/about" },
  { label: "Contact", to: "/contact" },
];
